import { fabric } from "fabric";
const activeObjectStore = store => {
  store.on("@init", () => ({ activeObject: {} }));
  store.on("activeObject/set", (_, activeObject) => {
    const newActiveObject = fabric.util.object.clone(activeObject);
    return { activeObject: newActiveObject };
  });
  store.on("activeObject/update", ({ activeObject }, newActiveObject) => {
    activeObject.scaleX = newActiveObject.scaleX;
    activeObject.scaleY = newActiveObject.scaleY;
    return { activeObject };
  });

  store.on("activeObject/updateFont", ({ activeObject }, newActiveObject) => {
    activeObject.fontFamily = newActiveObject.fontFamily;
    return { activeObject };
  });

  store.on("activeObject/remove", _ => {
    return { activeObject: {} };
  });
};

export default activeObjectStore;
